export default __webpack_public_path__ + "static/media/c7.647e5109.PNG";